import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

import { CubeJsChartType } from 'src/app/enums/cubejs-chart-type';
import { DateRangeCubeJs } from 'src/app/enums/cubejs/date-range';
import { GranularityCubeJs } from 'src/app/enums/cubejs/granularity';
import { GraphType } from 'src/app/enums/cubejs/graph-type';
import { BaseCubeJsGraphModel } from 'src/app/models/cubejs/baseCubeJsGraphModel';
import { ConvertValueModel } from 'src/app/models/cubejs/ConvertValueModel';
import { AlertService } from 'src/app/services';
import { CubeJsService } from 'src/app/services/cubeJs.service';


@Component({
    selector: 'app-plain-cube',
    templateUrl: './plain-cube.component.html',
    styleUrls: ['./plain-cube.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PlainCubeComponent extends BaseCubeJsGraphModel implements OnInit, OnChanges {

  @Input() Ititle: string;
  @Input() Iquery: any;
  @Input() IchartType: CubeJsChartType;
  @Input() IcurrentGranularity: GranularityCubeJs;
  @Input() IDateRangeCubeJs: DateRangeCubeJs;
  @Input() IgraphType: GraphType;
  @Input() IconvertValue: ConvertValueModel[];
  @Input() Iunit: any;
  @Input() IhasGranularity: boolean;
  @Input() IpivotConfig: any;
  @Input() Iitemisation: object;
  @Input() clickable: boolean;

  @Output() clickedChart = new EventEmitter<any>();

  constructor(private router: Router,
              private translate: TranslateService,
              private alertService: AlertService,
              protected cubeJsService: CubeJsService) {
    super(cubeJsService);
  }

  ngOnInit(): void {
    this.initDateRange();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.Iquery && changes.Iquery.currentValue) {
      if (this.IhasGranularity === false) {
        this.hasGranularity = false;
      }
      this.DEFAULT_CHART_TYPE = this.IchartType;
      this.currentGranularity = this.IcurrentGranularity;
      this.currentDateRange = this.IDateRangeCubeJs;
      this.graphType = new BehaviorSubject(this.IgraphType);
      this.convertValue = new BehaviorSubject<ConvertValueModel[]>(this.IconvertValue);
      this.unit = new BehaviorSubject(this.Iunit);

      this.setDefaultQuery();
      this.userWantsCustomDateRangeHandler(this.currentDateRange);

      this.setDefaultLoading();
      this.setDefaultFilter();
      this.setGranularityListByDateRange(this.currentDateRange as DateRangeCubeJs);
      this.dateRangeList = this.cubeJsService.getDateRangeList();
      this.initQuery();
    }
  }

  setDefaultQuery(): void {
    this.defaultQuery = this.Iquery;
  }

  setDefaultFilter(): void {
    this.defaultFilter = this.Iquery.filters;
  }

  initQuery(): void {
    this.cubeQuery.next(this.defaultQuery);
    this.chartType.next(this.DEFAULT_CHART_TYPE);
    this.pivotConfig.next(this.IpivotConfig);
  }

  //plain cube just transfert the click event
  transferEvent(event){
    this.clickedChart.emit(event);
  }
}
